export default function Footer() {
  return (
    <footer className="container mx-auto h-12 px-4 py-4 text-center text-sm text-gray-600 dark:text-gray-400">
      <p>© {new Date().getFullYear()} TrackToss. All rights reserved.</p>
    </footer>
  );
}
